export default "__VITE_ASSET__KaRgT5FP__"